export interface ShouldLinkCompanyProfileInput {
  companyId?: string | null;
  isTyomarkkinatori?: boolean | null;
}

/**
 * Company profile links are only shown when we have a concrete company id
 * and the listing is not sourced from Tyomarkkinatori.
 */
export function shouldLinkCompanyProfile({
  companyId,
  isTyomarkkinatori,
}: ShouldLinkCompanyProfileInput): boolean {
  const hasCompanyId = typeof companyId === 'string' && companyId.trim().length > 0;
  return hasCompanyId && !Boolean(isTyomarkkinatori);
}
